import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = { class: "card-title align-items-start flex-column" }
const _hoisted_3 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "card-body py-3" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3" }
const _hoisted_8 = { class: "fw-bolder text-muted" }
const _hoisted_9 = /*#__PURE__*/_createVNode("th", { class: "min-w-150px" }, "Id", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("th", { class: "min-w-150px" }, "Descripción", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("th", { class: "min-w-140px" }, "Tipo", -1)
const _hoisted_12 = { class: "min-w-140px" }
const _hoisted_13 = { class: "min-w-140px" }
const _hoisted_14 = { class: "text-dark fw-bolder fs-6" }
const _hoisted_15 = { class: "text-dark fw-bolder fs-6" }
const _hoisted_16 = { class: "text-dark fw-bolder fs-6" }
const _hoisted_17 = { class: "text-dark fw-bolder d-block mb-1 fs-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTModalCard = _resolveComponent("KTModalCard")
  const _component_KTCreateAPIKeyModal = _resolveComponent("KTCreateAPIKeyModal")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", {
    class: [_ctx.widgetClasses, "card"]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("h3", _hoisted_2, [
        _createVNode("span", _hoisted_3, _toDisplayString(_ctx.translate("devices")), 1)
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_KTModalCard, {
          device: _ctx.id,
          "button-text": "Cambiar Registros",
          "modal-id": "kt_modal_create_api_key"
        }, null, 8, ["device"]),
        _createVNode(_component_KTCreateAPIKeyModal, { device: _ctx.id }, null, 8, ["device"])
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode("table", _hoisted_7, [
          _createVNode("thead", null, [
            _createVNode("tr", _hoisted_8, [
              _hoisted_9,
              _hoisted_10,
              _hoisted_11,
              _createVNode("th", _hoisted_12, _toDisplayString(_ctx.translate("value")), 1),
              _createVNode("th", _hoisted_13, _toDisplayString(_ctx.translate("metrics")), 1)
            ])
          ]),
          _createVNode("tbody", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(JSON.parse(_ctx.records), (item, index) => {
              return (_openBlock(), _createBlock("tr", { key: index }, [
                _createVNode("td", null, [
                  _createVNode("a", _hoisted_14, _toDisplayString(index), 1)
                ]),
                _createVNode("td", null, [
                  _createVNode("a", _hoisted_15, _toDisplayString(_ctx.regdescript[index] ? _ctx.regdescript[index].split("[")[0] : ""), 1)
                ]),
                _createVNode("td", null, [
                  _createVNode("a", _hoisted_16, _toDisplayString(_ctx.regdescript[index]
                        ? _ctx.regdescript[index].split("[")[1].split("]")[0]
                        : ""), 1)
                ]),
                _createVNode("td", null, [
                  _createVNode("a", _hoisted_17, _toDisplayString(item), 1)
                ]),
                _createVNode("td", null, [
                  (_ctx.regmetrics[index])
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: {
                      name: 'device-statistics',
                      params: {
                        id: _ctx.id,
                        model: _ctx.model,
                        reg: index,
                        descrec: _ctx.regdescript[index].split('[')[0],
                        typerec: _ctx.regdescript[index].split('[')[1].split(']')[0]
                      }
                    },
                        class: "nav-link text-active-primary me-6",
                        "active-class": "active"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.translate("metrics")), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 2))
}